import PrivacyPolicy from '@/assets/fiestabet/pdf/privacy_policy.pdf';
import TermsAndConditions from '@/assets/fiestabet/pdf/terms_and_conditions.pdf';

export default {
  PrivacyPolicy,
  TermsAndConditions,
};
